// 全局 fetch 收口（JWT/SPA 迁移·阶段2b）
// 1) 保留既有行为：给所有请求注入 x-csrf-token（双轨期 CSRF 策略不变，见计划阶段1.4）
// 2) 新增：/api 请求注入 Authorization: Bearer <accessToken>
// 3) 新增：/api 响应 401 → 单飞 refresh（多并发只刷一次）→ 成功则重放一次 → 失败清 token 跳登录
//    （替代现状 208 个裸 fetch 静默吞 401 的行为；401 都出自 auth 中间件，未进控制器，重放安全）
import { tokenStore } from './token-store';

// 保存原始的 fetch 方法
const originalFetch = window.fetch;

// 定义辅助函数来从文档的 Cookie 中读取特定名称的值
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function urlOf(input) {
  if (typeof input === 'string') return input;
  if (input && typeof input.url === 'string') return input.url;
  return '';
}

function isApi(u) {
  return u.startsWith('/api') || /^https?:\/\/[^/]+\/api(\/|\?|#|$)/.test(u);
}

function withHeaders(init, u) {
  const headers = init.headers instanceof Headers
    ? init.headers
    : new Headers(init.headers || (Array.isArray(init.headers) ? init.headers : undefined));
  headers.set('x-csrf-token', getCookie('csrfToken') || '');
  const token = tokenStore.get();
  if (token && isApi(u)) headers.set('Authorization', 'Bearer ' + token);
  return { ...init, headers };
}

// ── 单飞 refresh：并发 401 共享同一个刷新 Promise ──────────────
let refreshing = null;
function doRefresh() {
  if (!refreshing) {
    refreshing = originalFetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'x-csrf-token': getCookie('csrfToken') || '' },
    })
      .then(async (r) => {
        if (!r.ok) return false;
        const j = await r.json().catch(() => null);
        if (j && j.success && j.data && j.data.accessToken) {
          tokenStore.set(j.data.accessToken);
          return true;
        }
        return false;
      })
      .catch(() => false)
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

function gotoLogin() {
  tokenStore.clear();
  const p = window.location.pathname;
  if (p === '/login' || p === '/regist' || p === '/forget' || p === '/regist2') return;
  window.location.href = '/login?return_url=' + encodeURIComponent(window.location.href);
}

// 重写 fetch 方法
window.fetch = async function (input, init = {}) {
  const u = urlOf(input);
  const api = isApi(u);

  let response = await originalFetch(input, withHeaders(init, u));

  if (api && response && response.status === 401 && u !== '/api/auth/refresh') {
    const refreshed = await doRefresh();
    if (refreshed) {
      response = await originalFetch(input, withHeaders(init, u));
    } else {
      gotoLogin();
    }
  }
  return response;
};

export default window.fetch;
